export const ILegacyAPIHTTPDataSourceType = Symbol('ILegacyAPIHTTPDataSource');
